import { render, staticRenderFns } from "./MoveProjects.vue?vue&type=template&id=5702e1ae&scoped=true&"
import script from "./MoveProjects.vue?vue&type=script&lang=js&"
export * from "./MoveProjects.vue?vue&type=script&lang=js&"
import style0 from "./MoveProjects.vue?vue&type=style&index=0&id=5702e1ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5702e1ae",
  null
  
)

export default component.exports